import { useEffect, useState } from "react";
import { subirArchivo } from "../services/services";

const APP = "Proveedores";

const useUploadFile = (fileName, initialFileList) => {
    const [fileList, setFileList] = useState([]);

    useEffect(() => {
        setFileList(initialFileList);
    }, [initialFileList]);

    const handleUploadFile = (options) => {
        let formData = new FormData();
        formData.append("File", options.file);
        formData.append(
            "Tags",
            `APP|${APP}^CONTEXTO|CONSTANCIAS^SUBCONTEXTO|${fileName}^CUIT|27345661471`
        );

        subirArchivo(formData)
            .then((data) => {
                console.log(data);
                options.onSuccess(data);
            })
            .catch((error) => {
                console.log(error);
                options.onError("Error al subir archivo");
            });
    };

    const handleChange = (info) => {
        let fileList = [...info.fileList];

        // Read from response and show file link
        fileList = fileList.map((file) => {
            if (file.response) {
                // Component will show file.url as link
                file.url = file.response.url;
            }
            return file;
        });

        setFileList(fileList);
    };

    return {
        fileList,
        handleUploadFile,
        handleChange,
    };
};

export default useUploadFile;
